import React, { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div
      className="overflow-hidden"
      style={{ backgroundColor:"#f3f4f6",fontFamily:""}}
    >
      <Navbar/>
      <main className=" mx-auto p-0  sm:p-0  lg:px-0 lg:pb-0 lg:pt-0">{children}</main>
      
      <Footer />
    </div>
  );
};

export default Layout;
